import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// 🔹 Add or Update Expense
export async function addExp(exp_data) {
  try {
    const fd = new FormData();
    fd.append("exp_data", btoa(JSON.stringify(exp_data)));

    const response = await axios.post(`${apiBaseUrl}exp/add_exp`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("addExp error:", error);
    return { status: false, type: "danger", success: "Failed to save expense" };
  }
}

// 🔹 Get Expenses
export async function getExps(page_no = 0, search_key = "",expanse_added_by="") {
  try {
    const fd = new FormData();
    fd.append("page_no", page_no);
    fd.append("search_key", search_key);
     fd.append("expanse_added_by", expanse_added_by);

    const response = await axios.post(`${apiBaseUrl}exp/get_exps`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("getExps error:", error);
    return { status: false, type: "danger", success: "Failed to fetch expenses" };
  }
}

// 🔹 Delete Expense
export async function deleteExp(expanse_id) {
  try {
    const fd = new FormData();
    fd.append("expanse_id", expanse_id);

    const response = await axios.post(`${apiBaseUrl}exp/delete_exp`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("deleteExp error:", error);
    return { status: false, type: "danger", success: "Failed to delete expense" };
  }
}

// 🔹 Get Expense By ID
export async function getExpById(expanse_id) {
  try {
    const fd = new FormData();
    fd.append("expanse_id", expanse_id);

    const response = await axios.post(`${apiBaseUrl}exp/get_exp_by_id`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("getExpById error:", error);
    return { status: false, type: "danger", success: "Failed to fetch expense details" };
  }
}

export async function getExpReport(expanse_added_by) {
  try {
    const fd = new FormData();
     fd.append("expanse_added_by", expanse_added_by);

    const response = await axios.post(`${apiBaseUrl}exp/get_exp_report`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getExpReport error:", error);
    return {
      status: false,
      type: "danger",
      success: "Failed to fetch expense report stats",
    };
  }
}
export async function importExpenses(file, userId) {
  try {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("user_id", userId);

    const response = await axios.post(
      `${apiBaseUrl}exp/import_exp`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("importExpenses error:", error);
    return { status: false, type: "danger", success: "Failed to import expenses" };
  }
}
export async function exportExpenses(userId) {
  try {
    const url = `${apiBaseUrl}exp/export_exp?expanse_added_by=${userId}`;

    const response = await axios.get(url, { responseType: "blob" });

    const blob = new Blob([response.data], { type: "text/csv" });
    const link = document.createElement("a");

    link.href = URL.createObjectURL(blob);
    link.download = "expenses_export.csv";
    link.click();

    return { status: true };
  } catch (error) {
    console.error("exportExpenses error:", error);
    return { status: false, type: "danger", success: "Failed to export expenses" };
  }
}
export async function downloadExpenseSample() {
  try {
    const url = `${apiBaseUrl}exp/download_exp_sample`;

    const response = await axios.get(url, { responseType: "blob" });

    const blob = new Blob([response.data], { type: "text/csv" });
    const link = document.createElement("a");

    link.href = URL.createObjectURL(blob);
    link.download = "expense_sample.csv";
    link.click();

    return { status: true };
  } catch (error) {
    console.error("downloadExpenseSample error:", error);
    return { status: false, type: "danger", success: "Failed to download sample" };
  }
}

